import { Component } from "../../core/Component";
import { UniversalComponent } from "~/modules/components/inputUniversal/Universal.component";
export class SelectComponent extends Component {
  constructor($root, options) {
    super($root, options);
    this.allStyle = options.allStyle || null;
    this.messages = options.messages;
    this.label = options.label || "";
    this.hint = options.hint || "";
    this.type = options.type || "select";
    this.require = options.required === 1;
    this.placeholder = options.placeholder || "";
    this.typeId = options.typeId;
    this.fieldId = options.id;
    this.option = false;
    this.defaultOption = null;
    this.classes = options.classes || "";
    // установка пользовательских классов оформления
    this.wrapClasses = this.makeWrapUserClasses();
    this.name = `${options.name}`;
    this.typeOpenSelect = false;
    this.value = null;
    this.key = null;
    this.id = `${options.name}_${options.formIndex}`; //${options.formId}_${options.formIndex}_${options.name}
    this.inputBoxId = `${options.name}_${options.formIndex}_input-box`;
    this.boxId = `${options.name}_${options.formIndex}_box`;
    this.headId = `${options.name}_${options.formIndex}_head`;
    this.listId = `${options.name}_${options.formIndex}_list`;
    this.errorBox = `${options.name}_${options.formIndex}_error-box`;
    this.errorBoxText = `${options.name}_${options.formIndex}_error-box_text`;
    this.labelId = `${options.name}_${options.formIndex}_label`;
    this.saveInStorage = this.options.data.saveInStorage;
  }
  /**
   *
   * @param {boolean | any[]} option - массив с вариантами выбора
   * @param {boolean} isMultipleCol - флаг добавления класса для нескольких колонок (используется при добавлении вариантов выбора)
   * @returns string
   */
  toHTML() {
    let option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let isMultipleCol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // Сохраняем опцию в свойство экземпляра
    this.option = option;

    // Формируем основные CSS-классы и переменные
    const wrapClasses = this.wrapClasses?.join(" ") || "";
    const hasHint = this.hint ? "qform-hint" : "";
    const multipleColClass = isMultipleCol ? "multiple-col" : "";

    // Генерация значения и класса для инпута
    const inputValue = this.defaultOption?.value || this.messages.selectChoose;
    const inputClass = !this.defaultOption?.value ? "qform-default-value" : "";

    // Собираем HTML по частям
    return `
    <div 
      class="qform-field select ${hasHint} ${wrapClasses} ${multipleColClass}" 
      id="${this.boxId}"
    >
      <div class="qform-field_wrap">
        ${this.toHtmlOutLabelBox()}
        <div class="qform-field__block">
          ${this.toHtmlAttBox("out_left")}
          ${this.toHtmlFieldBlock(inputValue, inputClass)}
          ${this.toHtmlAttBox("out_right")}
        </div>
        ${this.toHtmlBottomBox()}
      </div>
    </div>
  `;
  }

  /**
   * Генерирует блок с полем (внутренняя структура инпута и список)
   */
  toHtmlFieldBlock(inputValue, inputClass) {
    return `
    <div class="qform-field__block_box">
      <div class="qform-field__block_box__field" id="${this.headId}">
        ${this.toHtmlAttBox("in_left")}
        <div class="qform-field__block_box__field-box">
          ${this.toHtmlInputBox(inputValue, inputClass)}
          ${this.toHtmlOptionList()}
        </div>
        ${this.toHtmlAttBox("in_right")}
      </div>
    </div>
  `;
  }

  /**
   * Генерирует блок инпута (текст + иконка)
   */
  toHtmlInputBox(inputValue, inputClass) {
    return `
    <div class="qform-field__block_box__field-box_input" id="${this.inputBoxId}">
      <input 
        class="qform-field__block_box__field-box_input-text ${inputClass}" 
        id="${this.id}" 
        readonly 
        value="${this.escapeHtml(inputValue)}"
      />
      <div class="qform-field__block_box__field-box_input-icon"></div>
    </div>
  `;
  }

  /**
   * Генерирует блок списка опций
   */
  toHtmlOptionList() {
    return `
    <div class="qform-field__block_box__field-box_list">
      <div class="qform-field__block_box__field-box_list-box" id="${this.listId}">
        ${this.generateOptionItems()}
      </div>
    </div>
  `;
  }

  /**
   * Генерирует HTML для каждого элемента списка опций
   */
  generateOptionItems() {
    if (!this.option || !Array.isArray(this.option)) {
      return "";
    }
    return this.option.map((item, index) => {
      return `
        <div 
          class="qform-field__block_box__field-box_list__item ${this.classes || ""}" 
          data-option="${item.key}_${this.options.formIndex}"
        >
          ${this.escapeHtml(item.value)}
        </div>
      `;
    }).join("");
  }

  /**
   * Экранирует HTML-символы в строке для безопасного вывода в разметке
   * @param {string} str - Строка для экранирования
   * @returns {string} - Экранированная строка
   */
  escapeHtml(str) {
    if (typeof str !== "string") {
      return "";
    }
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }
  init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.$input = this.$root.$el.querySelector(`#${this.id}`);
    this.$input.disabled = disable;
    this.$inputBox = this.$root.$el.querySelector(`#${this.inputBoxId}`);
    this.$box = this.$root.$el.querySelector(`#${this.boxId}`);
    this.$head = this.$root.$el.querySelector(`#${this.headId}`);
    this.$list = this.$root.$el.querySelector(`#${this.listId}`);
    this.$label = this.$root.$el.querySelector(`#${this.labelId}`);
    this.$errorBox = this.$root.$el.querySelector(`#${this.errorBox}`);
    this.$errorBoxText = this.$root.$el.querySelector(`#${this.errorBoxText}`);
    this.$modal = this.$box.closest(".form-modal");
    this.listeners = [];
    if (this.$list) {
      this.listeners.push({
        eventName: "click",
        method: "onClickSetOption",
        el: this.$list
      });
    }

    //если форма в модальном окне
    if (this.options.formDisplayType === 1 && this.$modal) {
      this.listeners.push({
        eventName: "click",
        method: "selectMissClickHandler",
        el: this.$modal
      });
    }
    if (!disable) {
      this.listeners.push({
        eventName: "click",
        method: "selectMissClickHandler",
        el: document.body
      }, {
        eventName: "click",
        method: "onClick",
        el: this.$head
      });
    }
    super.init();

    // Извиняюсь за это
    setTimeout(() => {
      const storedData = JSON.parse(localStorage.getItem(this.options.formId));
      if (storedData && storedData[this.name]) {
        const savedKey = storedData[this.name].key;
        const selectedOption = this.option.find(x => x.key === savedKey);
        if (selectedOption) {
          this.setSelectedOption(selectedOption);
        }
      }
    }, 200);
    if (this.allStyle) {
      this.setClassField(this.allStyle);
    }
  }
  onClickSetOption(event) {
    event.preventDefault();
    const datasetOption = event.target.dataset.option;
    if (!datasetOption) return;
    const key = datasetOption.replace(/_(\d+)$/, ''); // формат: `${x.key}_${this.options.formIndex}`

    const selectedOption = this.option.find(x => x.key === key);

    if (!selectedOption) return;
    this.setSelectedOption(selectedOption);
  }

  /**
   * Устанавливает выбранное значение, обновляет DOM, генерирует события и сохраняет в localStorage
   * @param {FormFieldOption} optionObject - Сам объект опции
   */
  setSelectedOption(optionObject) {
    this.key = optionObject.key;
    this.value = optionObject.value;
    this.$input.value = optionObject.value;
    this.$input.classList.remove("qform-default-value");

    // Генерируем событие изменения
    const inputSetEvent = new CustomEvent("modify", {
      detail: {
        selectedKey: optionObject.key,
        selectedValue: optionObject.value
      }
    });
    this.$input.dispatchEvent(inputSetEvent);

    // Закрываем список
    this.$head.classList.remove(this.typeOpenSelect);
    this.$head.classList.remove("qform-field-focus");

    // Если опция требует дополнительного ввода
    if (optionObject?.isOther) {
      this.createOtherInputBox(optionObject);
    } else {
      this.hideOtherField();
    }

    // Валидация и событие
    this.validation();
    this.$emit("Change:field", {});

    // Сохранение в localStorage
    if (this.saveInStorage) {
      const storage = JSON.parse(localStorage.getItem(this.options.formId)) || {};
      storage[this.name] = {
        value: optionObject.value,
        key: optionObject.key
      };
      localStorage.setItem(this.options.formId, JSON.stringify(storage));
    }
  }
  selectMissClickHandler(event) {
    if (this.$head && !this.$head.contains(event.target)) {
      this.$head.classList.remove(this.typeOpenSelect);
      this.$head.classList.remove("qform-field-focus");
    }
  }
  onClick(event) {
    event.preventDefault();
    //проверяем, не было ли нажатия на вариант выбора
    if (this.typeOpenSelect && !event.target.className.includes("item")) {
      this.$head.classList.toggle(this.typeOpenSelect);
      this.$head.classList.toggle("qform-field-focus");
    }
  }
  onChange(event) {
    event.preventDefault();
    this.validation();
    this.$emit("Change:field", {});
  }
  getValue() {
    const value = [];
    if (this.otherInputComponent?.$input.value) {
      value.push(JSON.stringify({
        [this.key]: this.otherInputComponent.$input.value
      }));
    } else {
      value.push(this.key);
    }
    return {
      id: this.fieldId,
      name: this.name,
      typeId: this.typeId,
      values: this.key ? value : []
    };
  }
  validation() {
    let setMessageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let valid = true;
    if (this.require && this.key === null) {
      valid = false;
    }
    if (valid) {
      this.setMessageValid();
    } else {
      setMessageValid && this.setMessageValid(this.messages.inputRequired);
    }
    //если условие верно - поле валидно, и в нем есть данные, граница становится зеленой
    this.setSuccessValid(valid && this.$input.value.length && this.$input.value !== this.messages.selectChoose);
    return valid && (this.otherInputComponent?.validation() ?? true);
  }
  setClassField(data) {
    // .open | .open-gap
    if (data && typeof data.formStyleSelect !== "undefined" && typeof data.formStyleSelect.type !== "undefined") {
      if (data.formStyleSelect.type === 0) {
        this.typeOpenSelect = "open-gap";
        if (data.formStyleSelect.separatedIconType) {
          this.$inputBox.classList.add("background-icon");
        }
      } else if (data.formStyleSelect.type === 1) {
        this.typeOpenSelect = "open";
        if (data.formStyleSelect.combinedIconType) {
          this.$inputBox.classList.add("background-icon");
        }
      }
    } else {
      this.typeOpenSelect = "open";
    }
    if (!data.formStyleSelect.useDesign) {
      // // console.log('Удаляю класс Select')
      let arrClass = this.$root.$el.classList.value.split(" ");
      arrClass.forEach(nameClass => {
        if (nameClass.trim()) {
          this.$root.$el.classList.remove(nameClass);
        }
      });
    }
    // .required | .not-required
    if (data && typeof data.formStyleFieldRequired !== "undefined") {
      if (data.formStyleFieldRequired.type === 0 && this.require) {
        this.$box.classList.add("required");
      } else if (data.formStyleFieldRequired.type === 1 && !this.require) {
        this.$box.classList.add("not-required");
      }
      if (!data.formStyleFieldRequired.useDesign) {
        this.$box.classList.remove("required");
        this.$box.classList.remove("not-required");
      }
    }
  }
  setOption(options) {
    if (Array.isArray(options)) {
      let arrOption = [];
      options.forEach((option, i) => {
        if (option.formFieldId === this.fieldId) {
          arrOption.push(option);
          //если задано дефолтное значение селекта
          if (option.defaultValue && !this.defaultOption) {
            this.defaultOption = {
              value: option.value,
              key: option.key
            };
            this.value = this.defaultOption.value;
            this.key = this.defaultOption.key;
          }
        }
      });

      //добавляем разметку вариантов к форме
      let el;
      for (let i = 0; i < this.$root.$el.children.length; i++) {
        if (this.$root.$el.children[i].id === this.boxId) {
          el = this.$root.$el.children[i];
        }
      }
      el.insertAdjacentHTML("beforebegin", this.toHTML(arrOption, true));
      el.remove();
    }
    this.init({
      disable: !this.options.data.active
    });
  }

  /**
   * @param option {FormFieldOption}
   * */
  createOtherInputBox(option) {
    if (this.otherInputComponent) {
      this.otherInputComponent.validation(true);
      return;
    }
    this.otherInputComponent = new UniversalComponent(this.$root, {
      ...this.options,
      typeId: 12,
      name: `${this.options.name}_${option.key}`,
      label: "",
      required: 1,
      placeholder: '',
      hint: null,
      maxLength: 1000
    });
    const otherElement = document.createElement("div");
    otherElement.classList.add("qform-select-field-other-wrapper");
    otherElement.innerHTML = this.otherInputComponent.toHTML();
    this.$box.insertAdjacentHTML("beforeend", otherElement.outerHTML);
    this.otherInputComponent.init();
    this.otherInputComponent.validation();
  }
  hideOtherField() {
    this.otherInputComponent = null;
    this.$box.querySelectorAll(".qform-select-field-other-wrapper").forEach(el => {
      el.remove();
    });
  }
}